import { useMetricsTableStore } from '@devd-client/devd/components';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

// below function is what passes values to zustand. if any alteration of data is required we can do it
// in this function before passing to zustand. see teams switch case.

export enum GoalsActionTypes {
  default = '[Goals] Get Goals Data',
  authors = '[Goals] Set Clicked Goal',
}

export function useMetricTableHelpers() {
  const metricFilterBy = useMetricsTableStore();
  const [scrollToTop, setScrollToTop] = useState(false);
  const { pathname } = useLocation();
  const handleScrollToTop = () => {
    setScrollToTop(!scrollToTop);
  };

  const handleMetricFilterBy = (
    caseName: string,
    origin: string,
    value: string | null,
    ticketType: null | string,
    chartKey = '',
    metricKey = '',
    metric = '',
    heading = ''
  ) => {
    if (value === 'repos') {
      value = '';
    }
    switch (caseName) {
      // PR related
      case 'prFilters': {
        metricFilterBy.setPRValues(
          origin,
          value,
          chartKey,
          metricKey,
          metric,
          heading,
          pathname.split('/')[1] === 'contributors' ? 'contributor-profile' : ''
        );
        break;
      }

      case 'status': {
        metricFilterBy.setStatus(value ?? 'all');
        break;
      }

      case 'branchFilter': {
        metricFilterBy.setBranches(value ?? '');
        break;
      }

      // Issue Related
      case 'issueFilters': {
        metricFilterBy.setIssueValues(
          origin,
          value,
          ticketType,
          chartKey,
          metric,
          heading,
          pathname.split('/')[1] === 'contributors' ? 'contributor-profile' : ''
        );
        break;
      }

      case 'issueStatusType': {
        metricFilterBy.setIssueStatusType(value ?? 'all');
        break;
      }

      // Common filters
      case 'teams': {
        metricFilterBy.setTeam(value ?? '');
        break;
      }
      default:
        metricFilterBy.reset();
    }
  };

  return {
    handleMetricFilterBy,
    handleScrollToTop,
    scrollToTop,
  };
}

export default useMetricTableHelpers;
